// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"00c396fa","133":"58d4a7b8","227":"58d4a7b8","345":"e2fb147d"}[chunkId] + ".chunk.css";
};